<template>
  <div>
    <a-modal
      width="800px"
      v-model="managerVsisible"
      title="新增分配"
      @cancel="managerVsisible = false"
    >
      <template slot="footer">
        <a-button @click="managerVsisible = false">取消</a-button>
        <a-button type="primary" @click="handleOk">确定</a-button>
      </template>
      <a-form :form="form" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-row :gutter="24">
          <a-col :md="12" :sm="8">
            <a-form-item label="开始时间">
              <a-date-picker
                style="width: 100%"
                format="YYYY-MM-DD "
                placeholder="请选择开始时间"
                v-decorator="[
                  'beginTime',
                  {
                    rules: [
                      {
                        required: true,
                        message: '请输入开始时间!'
                      }
                    ]
                  }
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :md="12" :sm="8">
            <a-form-item label="结束时间">
              <a-date-picker
                style="width: 100%"
                format="YYYY-MM-DD "
                placeholder="请选择结束时间"
                v-decorator="['endTime', { initialValue: null }]"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :md="12" :sm="8">
            <a-form-item label="投资经理">
              <a-select
                mode="multiple"
                style="width: 100%"
                placeholder="请选择投资经理"
                @change="handleChange"
                v-decorator="['manager']"
              >
                <a-select-option
                  v-for="item in managerDataList"
                  :key="item.managerId"
                >
                  {{ item.managerName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="12" :sm="8" style="text-align:left;">
            <a-button type="primary" @click="confirmAdd">确认添加</a-button>
          </a-col>
        </a-row>
      </a-form>

      <div v-if="failDataList.length == 0">
        <div style="text-align:left;margin-bottom:10px">已添加</div>
        <a-table
          bordered
          rowKey="managerId"
          :columns="managerColumns"
          :data-source="selectManagers"
          :pagination="false"
          :loading="loading"
        >
          <span slot="action" slot-scope="text, record" class="handelDel">
            <a-button
              @click="handleDelete(record.id)"
              :disabled="record.id ? true : false"
              >删除</a-button
            >
            <!-- <a @click="handleDelete(record.id)" >删除</a> -->
          </span>
        </a-table>
      </div>
      <div v-if="failDataList.length > 0">
        <div style="text-align:left;margin-bottom:10px">分配失败</div>
        <a-table
          bordered
          rowKey="id"
          :columns="failColumns"
          :data-source="failDataList"
          :pagination="false"
          :loading="loading"
        >
          <span slot="action" slot-scope="text, record" class="handelDel">
            <a-button
              @click="handleDelete(record.id)"
              :disabled="record.id ? true : false"
              >删除</a-button
            >
            <!-- <a @click="handleDelete(record.id)" >删除</a> -->
          </span>
        </a-table>
      </div>
    </a-modal>
  </div>
</template>
<script>
import moment from 'moment';
import { getAllManager, bindManager, managerQueryById } from '@/api/product';
import { postTag } from '@/api/manage';
const failColumns = [
  {
    title: '产品名称',
    align: 'center',
    dataIndex: 'fundCode',
    ellipsis: true
  },
  {
    title: '产品代码',
    align: 'center',
    dataIndex: 'fundCode',
    ellipsis: true,
    customRender: text => {
      return !text || text == '' ? '--' : text;
    }
  },
  {
    title: '原因',
    align: 'center',
    dataIndex: 'result',
    ellipsis: true
  }
];
const managerColumns = [
  {
    title: '姓名',
    align: 'center',
    dataIndex: 'managerName',
    ellipsis: true
  },
  {
    title: '开始时间',
    align: 'center',
    dataIndex: 'beginTime',
    ellipsis: true,
    customRender: text => {
      return !text || text == '' ? '--' : text;
    }
  },
  {
    title: '结束时间',
    align: 'center',
    dataIndex: 'endTime',
    ellipsis: true
  },
  {
    title: '简介',
    align: 'center',
    dataIndex: 'managerIntroduction',
    ellipsis: true
  },
  {
    title: '操作',
    dataIndex: 'action',
    align: 'center',
    scopedSlots: { customRender: 'action' }
  }
];

export default {
  data() {
    return {
      failColumns,
      failDataList: [],
      form: this.$form.createForm(this),
      managerColumns,
      managerDataList: [],
      loading: false,
      vsisible: false,
      managerVsisible: false,
      managerAdd: process.env.VUE_APP_CMS_PRODUCT + '/product/relevance/add',
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 8
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 16
        }
      },
      managerIds: [],
      selectManagers: [],
      fundCode: '',
      fundName: '',
      fundId: '',
      managerId: '',
      url: {
        batchAdd:
          process.env.VUE_APP_CMS_PRODUCT + '/product/fund/manager/addBatch',
        managerList:
          process.env.VUE_APP_CMS_PRODUCT + '/product/fund/manager/listManager'
      },
      isBatch: false,
      selectedRowKeys: [],
      nowSelect: []
    };
  },

  methods: {
    //t投资经理回显
    checkManage() {
      let params = {
        fundCode: this.fundCode,
        pageNo: 1,
        pageSize: 1000
      };
      managerQueryById(params).then(res => {
        if (res.success) {
          this.selectManagers =
            res.result.records && res.result.records ? res.result.records : [];
        }
      });
    },
    // //获取投资经理
    // getManagerList() {
    //   // let params = {
    //   //   fundCode: this.fundCode
    //   // };
    //   let formdata = new FormData();
    //   formdata.append('fundCode', this.fundCode);
    //   getAllManager(formdata).then(res => {
    //     if (res.success) {
    //       this.managerDataList = res.result && res.result ? res.result : [];
    //     } else {
    //       this.$message.error(res.message);
    //     }
    //   });
    // },
    handleVisible(record, selectedRows) {
      if (!selectedRows) {
        this.isBatch = false;
        this.fundCode = record.fundCode;
        this.fundName = record.fundName;
        this.fundId = record.id;
        this.managerId = record.managerId;
        this.$nextTick(() => {
          this.checkManage();
          // this.getManagerList();

          this.form.resetFields();
        });
      } else {
        this.selectedRowKeys = [];
        selectedRows.map(item => {
          this.selectedRowKeys.push(item.fundCode);
        });

        this.isBatch = true;
        console.warn(this.selectedRowKeys);
      }
      this.managerVsisible = true;
      this.getAllManageList();
    },
    //所有投资经理
    getAllManageList() {
      let that = this;
      that.loading = true;
      postTag(this.url.managerList).then(res => {
        if (res.success) {
          that.managerDataList = res.result ? res.result : [];
          that.loading = false;
        }
      });
    },
    handleDelete(id) {
      let index = this.selectManagers.findIndex(item => item.id == id);
      let idx = this.nowSelect.findIndex(item => item.id == id);
      if (index > -1) {
        this.selectManagers.splice(index, 1);
      }
      if (idx > -1) {
        this.nowSelect.splice(index, 1);
      }
    },

    handleChange(value) {
      // let arr = [];
      // value.forEach(item => {
      //   let obj = this.managerDataList.find(ele => ele.id == item);
      //   arr.push(obj);
      // });
      this.managerIds = value;
    },
    confirmAdd() {
      this.form.validateFields((err, values) => {
        if (!err) {
          let arr = [];

          this.managerIds.forEach(item => {
            let obj = this.managerDataList.find(e => e.managerId == item);
            if (obj) {
              obj.beginTime = values.beginTime
                ? moment(values.beginTime).format('YYYY-MM-DD')
                : null;
              obj.endTime = values.endTime
                ? moment(values.endTime).format('YYYY-MM-DD')
                : null;
              arr.push(obj);
            }
          });
          this.nowSelect = this.nowSelect.concat(arr);
          console.warn(this.nowSelect, ' this.nowSelect');
          if (this.selectManagers.length == 0) {
            this.selectManagers = this.selectManagers.concat(arr);
          } else {
            let isConcat = true;
            console.warn(arr);

            if (isConcat) {
              this.selectManagers = this.selectManagers.concat(arr);
            }
            console;
          }

          this.form.setFieldsValue({ manager: [] });
        }
      });
    },
    handleOk() {
      let that = this;
      if (that.selectManagers.length <= 0) {
        that.$message.warning('至少选择一个投资经理');
        return;
      } else {
        that.form.validateFields((err, values) => {
          // console.warn(values.endTime == null);
          if (!err) {
            let endTime;
            values.endTime == null
              ? (endTime = '')
              : (endTime = moment(values.endTime).format('YYYY-MM-DD'));
            // let managerArr = []
            // managerArr.
            let params = {
              managers: this.nowSelect
            };
            if (this.isBatch) {
              params.fundCodes = this.selectedRowKeys;
              postTag(this.url.batchAdd, params).then(res => {
                if (res.success) {
                  that.managerVsisible = false;
                  that.$emit('initFundList', '1');
                  that.selectManagers = [];
                  that.nowSelect = [];
                  that.$message.success(res.message);
                } else {
                  that.$message.error(res.message);
                }
              });
            } else {
              params.fundCode = this.fundCode;

              bindManager(params).then(res => {
                if (res.success) {
                  that.managerVsisible = false;
                  that.$message.success(res.message);
                  that.$emit('initFundList', '1');
                  that.selectManagers = [];
                  that.nowSelect = [];
                } else {
                  that.$message.error(res.message);
                  that.nowSelect = [];
                }
              });
            }
          }
        });
      }
    },

    initManagerByFundCode(arr) {
      this.selectManagers = arr;
    }
  }
};
</script>
<style scoped lang="less">
.handelDel {
  button {
    border: none;
    color: #1890ff;
    background-color: unset;
  }
}
</style>
